/**
 * Color Variant Selector - Simple Link Version
 * Handles navigation between separate product pages for each color
 * No variant switching - each color is a different product
 */

document.addEventListener('DOMContentLoaded', function() {
    console.log('[COLOR VARIANT] Simple link-based color selector initialized');
    
    // Check if we're on a collection page
    const isCollectionPage = document.body.classList.contains('template-collection') || 
                           window.location.pathname.includes('/collections/');
    
    // Enhanced mobile carousel functionality for collection/catalog pages
    if (isCollectionPage && window.innerWidth <= 768) {
        initializeMobileCarousel();
    }
    
    // Update color label on hover (product pages only)
    const allColorVariants = document.querySelectorAll('.color-variant');
    
    allColorVariants.forEach(variant => {
        const container = variant.closest('.color-variants-container');
        if (!container) return;
        
        const label = container.querySelector('.color-variant-label-text');
        
        // Product page functionality - label updates
        if (label && !isCollectionPage) {
            // Store the original color text
            if (!label.dataset.originalColor) {
                label.dataset.originalColor = label.textContent;
            }
            
            variant.addEventListener('mouseenter', function() {
                // Update label to show hovered color
                const hoveredColor = this.dataset.color;
                if (hoveredColor) {
                    label.textContent = hoveredColor;
                }
                
                // Preload the linked page for faster navigation
                if (!this.classList.contains('active')) {
                    const link = this.href;
                    if (link && !this.dataset.preloaded) {
                        const prefetchLink = document.createElement('link');
                        prefetchLink.rel = 'prefetch';
                        prefetchLink.href = link;
                        document.head.appendChild(prefetchLink);
                        this.dataset.preloaded = 'true';
                    }
                }
            });
            
            variant.addEventListener('mouseleave', function() {
                // Restore original color text
                label.textContent = label.dataset.originalColor;
            });
        }
        
        // Collection page functionality - image swapping
        if (isCollectionPage) {
            const card = variant.closest('.card-wrapper') || variant.closest('.card');
            if (!card) return;
            
            const cardMedia = card.querySelector('.card__media img') || card.querySelector('.media img');
            if (!cardMedia) return;
            
            // Store original image data
            if (!cardMedia.dataset.originalSrc) {
                cardMedia.dataset.originalSrc = cardMedia.src;
                cardMedia.dataset.originalSrcset = cardMedia.srcset || '';
            }
            
            // Handle hover - swap image
            variant.addEventListener('mouseenter', function() {
                const variantImg = this.querySelector('img');
                if (variantImg && variantImg.src) {
                    // Get larger version of the variant image
                    const largeSrc = variantImg.src.replace('width=80', 'width=600');
                    cardMedia.src = largeSrc;
                    // Clear srcset to prevent conflicts
                    cardMedia.srcset = '';
                }
            });
            
            // Handle mouse leave - restore original image
            variant.addEventListener('mouseleave', function() {
                cardMedia.src = cardMedia.dataset.originalSrc;
                cardMedia.srcset = cardMedia.dataset.originalSrcset;
            });
            
            // Handle click on collection pages - navigate to product
            variant.addEventListener('click', function(e) {
                // Allow normal link behavior on collection pages
                window.location.href = this.href;
            });
        }
    });
    
    // Optional: Add keyboard navigation support
    document.addEventListener('keydown', function(e) {
        if (e.target.classList.contains('color-variant')) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                window.location.href = e.target.href;
            }
        }
    });
    
    // Mobile carousel initialization function
    function initializeMobileCarousel() {
        const colorVariantContainers = document.querySelectorAll('.card .color-variants, .card-wrapper .color-variants');
        
        colorVariantContainers.forEach(container => {
            let isScrolling = false;
            let startX = 0;
            let scrollStart = 0;
            
            // Add touch event listeners for better mobile interaction
            container.addEventListener('touchstart', function(e) {
                isScrolling = false;
                startX = e.touches[0].clientX;
                scrollStart = container.scrollLeft;
            }, { passive: true });
            
            container.addEventListener('touchmove', function(e) {
                if (!isScrolling) {
                    isScrolling = true;
                    container.style.scrollBehavior = 'auto'; // Disable smooth scroll during touch
                }
                
                const currentX = e.touches[0].clientX;
                const diff = startX - currentX;
                container.scrollLeft = scrollStart + diff;
            }, { passive: true });
            
            container.addEventListener('touchend', function(e) {
                container.style.scrollBehavior = 'smooth'; // Re-enable smooth scroll
                isScrolling = false;
                
                // Snap to nearest variant after swipe
                const variantWidth = container.querySelector('.color-variant').offsetWidth;
                const gap = 8; // Gap between variants
                const itemWidth = variantWidth + gap;
                const scrollPosition = container.scrollLeft;
                const snapIndex = Math.round(scrollPosition / itemWidth);
                const snapPosition = snapIndex * itemWidth;
                
                container.scrollTo({
                    left: snapPosition,
                    behavior: 'smooth'
                });
            }, { passive: true });
            
            // Handle mouse events for desktop testing
            let isMouseDown = false;
            let mouseStartX = 0;
            let mouseScrollStart = 0;
            
            container.addEventListener('mousedown', function(e) {
                if (window.innerWidth > 768) return; // Only for mobile simulation
                isMouseDown = true;
                mouseStartX = e.clientX;
                mouseScrollStart = container.scrollLeft;
                container.style.cursor = 'grabbing';
                e.preventDefault();
            });
            
            container.addEventListener('mousemove', function(e) {
                if (!isMouseDown || window.innerWidth > 768) return;
                const currentX = e.clientX;
                const diff = mouseStartX - currentX;
                container.scrollLeft = mouseScrollStart + diff;
            });
            
            container.addEventListener('mouseup', function(e) {
                if (window.innerWidth > 768) return;
                isMouseDown = false;
                container.style.cursor = 'grab';
            });
            
            container.addEventListener('mouseleave', function(e) {
                if (window.innerWidth > 768) return;
                isMouseDown = false;
                container.style.cursor = 'grab';
            });
            
            // Add visual feedback for scrollable containers
            const variants = container.querySelectorAll('.color-variant');
            if (variants.length > 4) { // If more than 4 variants, mark as scrollable
                container.classList.add('scrollable-variants');
                // Arrow indicator removed - handled by mobile-color-carousel.js
            }
        });
    }
    
    // Re-initialize on window resize
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            if (isCollectionPage && window.innerWidth <= 768) {
                initializeMobileCarousel();
            }
        }, 250);
    });
    
});
